import React from 'react'

import Image from 'next/image'

import { PaddingProps } from 'styled-system'

import { Breadcrumbs, SectionWrapper } from 'Components/Blocks'
import { Button, Column, Text } from 'Components/UI'

import { TeamImage } from 'Assets/Image'

import { COMPANY } from 'Constants/Paths'

import { useAppContext } from 'Services/AppContext'

import { Content, ImageHolder } from './styles'

type Props = PaddingProps

function CompanyHeroSection({ ...rest }: Props) {
  const { openSupportWidget } = useAppContext()

  return (
    <SectionWrapper {...rest}>
      <Content
        flexDirection={[
          'column',
          'column',
          'column',
          'column',
          'column',
          'row',
        ]}
        gap={[19, 19, 17, 17, 17, 11]}
      >
        <Column
          alignStart
          fullWidth
          maxWidth={['100%', '100%', '100%', '100%', '100%', '640px']}
        >
          <Breadcrumbs paths={[{ caption: 'Company', href: COMPANY }]} />

          <Text mb={5} medium mt={9} title title52>
            A decade of building
            <br />
            the systems businesses run on.
          </Text>

          <Text body body16 maxWidth="640px" mb={9} semiLight>
            StartupCraft has spent ten years building operational software for
            businesses whose work still runs on spreadsheets, paper dockets and
            people re-keying the same data twice. Senior engineers, one office
            in Sydney, and a paid discovery before anyone writes code.
          </Text>

          <Button onClick={openSupportWidget}>Book a paid discovery</Button>
        </Column>

        <Column alignEnd fullWidth>
          <ImageHolder maxWidth={['unset', 'unset', 'unset', 'unset', '640px']}>
            <Image
              alt="The StartupCraft team at the 2018 annual meetup in Batumi, Georgia"
              src={TeamImage}
            />
          </ImageHolder>

          <Text body body12 mb={4} medium mt={6} right>
            StartupCraft Annual Meetup, 2018 – Batumi, Georgia
          </Text>

          <Text body body12 maxWidth="420px" right semiLight>
            Remote-first. Still tight-knit. Every year, we gather in one place
            to reset, reconnect, and celebrate the work we’ve shipped together.
          </Text>
        </Column>
      </Content>
    </SectionWrapper>
  )
}

export default CompanyHeroSection
